'use client';

import { Button, ButtonProps } from '@mui/material';
import { keyframes } from '@emotion/react';

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export default function ShimmerButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        ...(props.sx || {}),
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '-150%',
          width: '150%',
          height: '100%',
          background:
            'linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent)',
          transform: 'skewX(-25deg)',
        },
        '&:hover:before': {
          animation: `${shimmer} 0.75s ease-in-out`,
        },
      }}
    />
  );
}
